export const LogLevel = Object.freeze({
  trace: 0,
  debug: 1,
  info: 2,
  warn: 3,
  error: 4,
  fatal: 5,
});

export class Logger {
  static _logLevel = LogLevel.trace;

  static get logLevel() {
    return Logger._logLevel;
  }

  static setLogLevel(level) {
    Logger._logLevel = level;
  }

  constructor(context, logLevel = Logger.logLevel) {
    this._context = context;
    this._logLevel = logLevel;
  }

  get context() {
    return this._context;
  }

  get logLevel() {
    return this._logLevel;
  }

  _log(logLevel, ...args) {
    if (this.isLogLevelEnabled(logLevel)) console.log(`[${LogLevel[logLevel]}]`, `[${this.context}]`, ...args);
  }

  isLogLevelEnabled(logLevel) {
    return logLevel >= this.logLevel;
  }

  trace(...args) {
    this._log(LogLevel.trace, ...args);
  }

  debug(...args) {
    this._log(LogLevel.debug, ...args);
  }

  log(...args) {
    this._log(LogLevel.debug, ...args);
  }

  info(...args) {
    this._log(LogLevel.info, ...args);
  }

  warn(...args) {
    this._log(LogLevel.warn, ...args);
  }

  error(...args) {
    this._log(LogLevel.error, ...args);
  }

  fatal(...args) {
    this._log(LogLevel.fatal, ...args);
  }
}
